var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockinline = function SvgClockinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 3c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#EF6922"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.434 10.697a1.5 1.5 0 0 1 1.334 2.687l-3.023 1.5a1.5 1.5 0 0 1-2.167-1.344V7.377a1.5 1.5 0 0 1 3 0v3.745l.856-.425Z",
    fill: "#EF6922"
  })));
};
export default SvgClockinline;